export default __webpack_public_path__ + "static/media/asset-confetti-bolsa.fa3814e0.gif";